export default __webpack_public_path__ + "static/media/eVAS-Privacy_Policy.038fe30b.pdf";